/**
 * useMyLeaveBalance — 106-2 React Query hook saját leave egyenlegéhez.
 *
 * A backend `/hr/leave/my-balance/:year` endpoint JWT user-id-ből deduce-olja
 * az employeeProfileId-t, így a frontend-nek NEM kell külön lekérnie.
 */

import { useQuery } from '@tanstack/react-query';
import { getMyLeaveBalance, type LeaveBalance } from '../api/hr-api';

export function myLeaveBalanceQueryKey(year: number) {
  return ['hr', 'leave', 'my-balance', year] as const;
}

export interface MyLeaveBalanceResult {
  balances: LeaveBalance[];
  employeeProfileId: string;
}

export function useMyLeaveBalance(year: number) {
  return useQuery<MyLeaveBalanceResult>({
    queryKey: myLeaveBalanceQueryKey(year),
    queryFn: async () => {
      const res = await getMyLeaveBalance(year);
      return { balances: res.data, employeeProfileId: res.employeeProfileId };
    },
    staleTime: 60_000,
  });
}
